// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Analytics Panel Styles
 * Memex Racing Game - Race History and Analytics Dashboard
 */

/* Analytics Panel Container */
#analytics-panel {
    position: fixed;
    top: 20px;
    right: 20px;
    width: 800px;
    max-height: 80vh;
    background: linear-gradient(135deg, #1a3a1a, #2a4a2a);
    border: 2px solid #0088ff;
    border-radius: 8px;
    color: #ffffff;
    font-family: 'Courier New', monospace;
    box-shadow: 0 4px 20px rgba(0, 255, 0, 0.3);
    z-index: 1000;
    overflow: hidden;
    transition: all 0.3s ease;
}

#analytics-panel.hidden {
    transform: translateX(100%);
    opacity: 0;
}

/* Panel Header */
.panel-header {
    background: rgba(0, 255, 0, 0.1);
    border-bottom: 1px solid #0088ff;
    padding: 12px 16px;
}

.panel-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title-text {
    font-size: 16px;
    font-weight: bold;
    color: #0088ff;
    text-shadow: 0 0 10px rgba(0, 255, 0, 0.5);
}

.panel-controls {
    display: flex;
    gap: 8px;
    align-items: center;
}

.timeframe-selector {
    background: #2a4a2a;
    border: 1px solid #0088ff;
    border-radius: 4px;
    color: #ffffff;
    padding: 4px 8px;
    font-size: 12px;
    font-family: inherit;
}

.control-btn {
    width: 28px;
    height: 28px;
    background: #2a4a2a;
    border: 1px solid #0088ff;
    border-radius: 4px;
    color: #0088ff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    transition: all 0.2s ease;
}

.control-btn:hover {
    background: #0088ff;
    color: #1a3a1a;
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.5);
}

/* Panel Body */
.panel-body {
    max-height: calc(80vh - 60px);
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #0088ff #2a4a2a;
}

.panel-body::-webkit-scrollbar {
    width: 8px;
}

.panel-body::-webkit-scrollbar-track {
    background: #2a4a2a;
}

.panel-body::-webkit-scrollbar-thumb {
    background: #0088ff;
    border-radius: 4px;
}

/* Analytics Tabs */
.analytics-tabs {
    display: flex;
    background: rgba(0, 255, 0, 0.05);
    border-bottom: 1px solid #0088ff;
    overflow-x: auto;
}

.tab-btn {
    background: transparent;
    border: none;
    color: #cccccc;
    padding: 12px 16px;
    cursor: pointer;
    font-family: inherit;
    font-size: 12px;
    white-space: nowrap;
    transition: all 0.2s ease;
    border-bottom: 2px solid transparent;
}

.tab-btn:hover {
    color: #ffffff;
    background: rgba(0, 255, 0, 0.1);
}

.tab-btn.active {
    color: #0088ff;
    border-bottom-color: #0088ff;
    background: rgba(0, 255, 0, 0.1);
}

/* Tab Content */
.analytics-tabs-content {
    padding: 16px;
}

.tab-content {
    display: none;
}

.tab-content.active {
    display: block;
}

/* Overview Tab Styles */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
}

.stat-card {
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 6px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    transition: all 0.2s ease;
}

.stat-card:hover {
    border-color: #0088ff;
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.2);
}

.stat-icon {
    font-size: 24px;
    opacity: 0.8;
}

.stat-content {
    flex: 1;
}

.stat-value {
    font-size: 20px;
    font-weight: bold;
    color: #0088ff;
    line-height: 1;
}

.stat-label {
    font-size: 11px;
    color: #cccccc;
    text-transform: uppercase;
    margin-top: 4px;
}

/* Charts */
.overview-charts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.chart-container {
    background: rgba(0, 255, 0, 0.02);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 6px;
    padding: 16px;
}

.chart-container h3 {
    margin: 0 0 12px 0;
    font-size: 14px;
    color: #0088ff;
}

.chart-container canvas {
    width: 100%;
    height: auto;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
}

/* Players Tab Styles */
.players-analytics {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
}

.top-players-section h3,
.player-stats-section h3 {
    margin: 0 0 16px 0;
    font-size: 16px;
    color: #0088ff;
    border-bottom: 1px solid rgba(0, 255, 0, 0.3);
    padding-bottom: 8px;
}

.players-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.top-player-card {
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 6px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.top-player-card:hover {
    border-color: #0088ff;
    background: rgba(0, 255, 0, 0.1);
}

.top-player-card.rank-1 {
    border-color: #ffd700;
    background: rgba(255, 215, 0, 0.1);
}

.top-player-card.rank-2 {
    border-color: #c0c0c0;
    background: rgba(192, 192, 192, 0.1);
}

.top-player-card.rank-3 {
    border-color: #cd7f32;
    background: rgba(205, 127, 50, 0.1);
}

.player-rank {
    font-size: 18px;
    font-weight: bold;
    color: #0088ff;
    min-width: 30px;
}

.player-info {
    flex: 1;
}

.player-name {
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 4px;
}

.player-stats {
    display: flex;
    gap: 12px;
    font-size: 11px;
    color: #cccccc;
}

.player-score {
    font-size: 16px;
    font-weight: bold;
    color: #0088ff;
}

/* Player Search */
.player-search {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
}

.player-search input {
    flex: 1;
    background: #2a4a2a;
    border: 1px solid #0088ff;
    border-radius: 4px;
    color: #ffffff;
    padding: 8px 12px;
    font-family: inherit;
    font-size: 12px;
}

.player-search button {
    background: #2a4a2a;
    border: 1px solid #0088ff;
    border-radius: 4px;
    color: #0088ff;
    padding: 8px 12px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.player-search button:hover {
    background: #0088ff;
    color: #1a3a1a;
}

/* Player Details */
.player-details {
    background: rgba(0, 255, 0, 0.02);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 6px;
    padding: 16px;
    min-height: 200px;
}

.no-selection {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #666666;
    font-style: italic;
}

.player-header {
    margin-bottom: 16px;
    border-bottom: 1px solid rgba(0, 255, 0, 0.3);
    padding-bottom: 8px;
}

.player-header .player-name {
    font-size: 18px;
    color: #0088ff;
    margin-bottom: 4px;
}

.player-id {
    font-size: 11px;
    color: #666666;
}

.player-stats-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 16px;
}

.stat-item {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
}

.stat-item .label {
    color: #cccccc;
    font-size: 11px;
}

.stat-item .value {
    color: #ffffff;
    font-weight: bold;
}

.trend-improving {
    color: #0088ff !important;
}

.trend-declining {
    color: #ff6600 !important;
}

.trend-stable {
    color: #ffff00 !important;
}

/* Races Tab Styles */
.race-filters {
    display: flex;
    gap: 16px;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(0, 255, 0, 0.2);
}

.race-filters select {
    background: #2a4a2a;
    border: 1px solid #0088ff;
    border-radius: 4px;
    color: #ffffff;
    padding: 6px 10px;
    font-size: 12px;
    font-family: inherit;
}

/* Tables */
.races-table,
.bets-table {
    background: rgba(0, 255, 0, 0.02);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 6px;
    overflow: hidden;
}

.table-header {
    background: rgba(0, 255, 0, 0.1);
    display: grid;
    grid-template-columns: 1fr 1fr 80px 60px 1fr;
    padding: 8px 12px;
    font-size: 11px;
    font-weight: bold;
    color: #0088ff;
    text-transform: uppercase;
}

.table-row {
    display: grid;
    grid-template-columns: 1fr 1fr 80px 60px 1fr;
    padding: 8px 12px;
    font-size: 12px;
    border-top: 1px solid rgba(0, 255, 0, 0.1);
    transition: background 0.2s ease;
}

.table-row:hover {
    background: rgba(0, 255, 0, 0.05);
}

.table-row.win {
    border-left: 3px solid #0088ff;
}

.table-row.lose {
    border-left: 3px solid #ff6600;
}

.table-row.pending {
    border-left: 3px solid #ffff00;
}

/* Betting Tab Styles */
.betting-stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
}

.betting-stat-card {
    background: rgba(255, 102, 0, 0.05);
    border: 1px solid rgba(255, 102, 0, 0.3);
    border-radius: 6px;
    padding: 16px;
    text-align: center;
}

.betting-stat-card .stat-value {
    font-size: 18px;
    font-weight: bold;
    color: #ff6600;
    line-height: 1;
}

.betting-stat-card .stat-label {
    font-size: 11px;
    color: #cccccc;
    text-transform: uppercase;
    margin-top: 4px;
}

.betting-charts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 24px;
}

/* Maps Tab Styles */
.map-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
}

.map-stat-card {
    background: rgba(255, 255, 0, 0.05);
    border: 1px solid rgba(255, 255, 0, 0.3);
    border-radius: 6px;
    padding: 16px;
}

.map-name {
    font-size: 14px;
    font-weight: bold;
    color: #ffff00;
    margin-bottom: 12px;
    text-transform: uppercase;
}

.map-stats-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
}

.map-stat {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
}

.map-stat .label {
    color: #cccccc;
}

.map-stat .value {
    color: #ffffff;
    font-weight: bold;
}

/* Trends Tab Styles */
.trend-indicators {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
}

.trend-card {
    background: rgba(0, 255, 255, 0.05);
    border: 1px solid rgba(0, 255, 255, 0.3);
    border-radius: 6px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.trend-icon {
    font-size: 24px;
}

.trend-value {
    font-size: 16px;
    font-weight: bold;
    line-height: 1;
}

.trend-value.positive {
    color: #0088ff;
}

.trend-value.negative {
    color: #ff6600;
}

.trend-value.neutral {
    color: #ffff00;
}

.trend-label {
    font-size: 11px;
    color: #cccccc;
    text-transform: uppercase;
    margin-top: 4px;
}

.trend-charts {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
}

/* Notifications */
.notification {
    position: fixed;
    top: 10px;
    right: 10px;
    background: #2a4a2a;
    border: 1px solid #0088ff;
    border-radius: 4px;
    color: #ffffff;
    padding: 8px 16px;
    font-size: 12px;
    z-index: 2000;
    opacity: 0;
    transform: translateX(100%);
    transition: all 0.3s ease;
}

.notification.show {
    opacity: 1;
    transform: translateX(0);
}

.notification.success {
    border-color: #0088ff;
    background: rgba(0, 255, 0, 0.1);
}

.notification.error {
    border-color: #ff6600;
    background: rgba(255, 102, 0, 0.1);
}

.notification.info {
    border-color: #ffff00;
    background: rgba(255, 255, 0, 0.1);
}

/* Responsive Design */
@media (max-width: 1024px) {
    #analytics-panel {
        width: 90vw;
        right: 5vw;
    }
    
    .players-analytics {
        grid-template-columns: 1fr;
    }
    
    .overview-charts {
        grid-template-columns: 1fr;
    }
    
    .betting-charts {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    #analytics-panel {
        width: 95vw;
        right: 2.5vw;
        max-height: 90vh;
    }
    
    .stats-grid {
        grid-template-columns: 1fr 1fr;
    }
    
    .betting-stats-grid {
        grid-template-columns: 1fr 1fr;
    }
    
    .map-stats {
        grid-template-columns: 1fr;
    }
    
    .trend-indicators {
        grid-template-columns: 1fr;
    }
    
    .table-header,
    .table-row {
        font-size: 10px;
        padding: 6px 8px;
    }
}

/* Animation Classes */
.updating {
    opacity: 0.7;
    transition: opacity 0.3s ease;
}

.chart-loading {
    position: relative;
}

.chart-loading::after {
    content: "Loading...";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #0088ff;
    font-size: 14px;
}

/* No Data States */
.no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    color: #666666;
    font-style: italic;
    border: 1px dashed rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/ui/styles/analytics-panel.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,8BAA8B;AAC9B;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,qDAAqD;IACrD,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,qCAAqC;IACrC,2CAA2C;IAC3C,aAAa;IACb,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,UAAU;AACd;;AAEA,iBAAiB;AACjB;IACI,gCAAgC;IAChC,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yCAAyC;AAC7C;;AAEA,eAAe;AACf;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,iCAAiC;IACjC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA,gBAAgB;AAChB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,oBAAoB;AACxB;;AAEA,WAAW;AACX;;IAEI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,4CAA4C;IAC5C,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,iBAAiB;IACjB,eAAe;IACf,0CAA0C;IAC1C,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;AACb;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA,sBAAsB;AACtB;IACI;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA,sBAAsB;AACtB;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,cAAc;IACd,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,2CAA2C;IAC3C,kBAAkB;IAClB,8BAA8B;AAClC","sourcesContent":["/**\n * Analytics Panel Styles\n * Memex Racing Game - Race History and Analytics Dashboard\n */\n\n/* Analytics Panel Container */\n#analytics-panel {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    width: 800px;\n    max-height: 80vh;\n    background: linear-gradient(135deg, #1a3a1a, #2a4a2a);\n    border: 2px solid #0088ff;\n    border-radius: 8px;\n    color: #ffffff;\n    font-family: 'Courier New', monospace;\n    box-shadow: 0 4px 20px rgba(0, 255, 0, 0.3);\n    z-index: 1000;\n    overflow: hidden;\n    transition: all 0.3s ease;\n}\n\n#analytics-panel.hidden {\n    transform: translateX(100%);\n    opacity: 0;\n}\n\n/* Panel Header */\n.panel-header {\n    background: rgba(0, 255, 0, 0.1);\n    border-bottom: 1px solid #0088ff;\n    padding: 12px 16px;\n}\n\n.panel-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.title-text {\n    font-size: 16px;\n    font-weight: bold;\n    color: #0088ff;\n    text-shadow: 0 0 10px rgba(0, 255, 0, 0.5);\n}\n\n.panel-controls {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.timeframe-selector {\n    background: #2a4a2a;\n    border: 1px solid #0088ff;\n    border-radius: 4px;\n    color: #ffffff;\n    padding: 4px 8px;\n    font-size: 12px;\n    font-family: inherit;\n}\n\n.control-btn {\n    width: 28px;\n    height: 28px;\n    background: #2a4a2a;\n    border: 1px solid #0088ff;\n    border-radius: 4px;\n    color: #0088ff;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    transition: all 0.2s ease;\n}\n\n.control-btn:hover {\n    background: #0088ff;\n    color: #1a3a1a;\n    box-shadow: 0 0 10px rgba(0, 255, 0, 0.5);\n}\n\n/* Panel Body */\n.panel-body {\n    max-height: calc(80vh - 60px);\n    overflow-y: auto;\n    scrollbar-width: thin;\n    scrollbar-color: #0088ff #2a4a2a;\n}\n\n.panel-body::-webkit-scrollbar {\n    width: 8px;\n}\n\n.panel-body::-webkit-scrollbar-track {\n    background: #2a4a2a;\n}\n\n.panel-body::-webkit-scrollbar-thumb {\n    background: #0088ff;\n    border-radius: 4px;\n}\n\n/* Analytics Tabs */\n.analytics-tabs {\n    display: flex;\n    background: rgba(0, 255, 0, 0.05);\n    border-bottom: 1px solid #0088ff;\n    overflow-x: auto;\n}\n\n.tab-btn {\n    background: transparent;\n    border: none;\n    color: #cccccc;\n    padding: 12px 16px;\n    cursor: pointer;\n    font-family: inherit;\n    font-size: 12px;\n    white-space: nowrap;\n    transition: all 0.2s ease;\n    border-bottom: 2px solid transparent;\n}\n\n.tab-btn:hover {\n    color: #ffffff;\n    background: rgba(0, 255, 0, 0.1);\n}\n\n.tab-btn.active {\n    color: #0088ff;\n    border-bottom-color: #0088ff;\n    background: rgba(0, 255, 0, 0.1);\n}\n\n/* Tab Content */\n.analytics-tabs-content {\n    padding: 16px;\n}\n\n.tab-content {\n    display: none;\n}\n\n.tab-content.active {\n    display: block;\n}\n\n/* Overview Tab Styles */\n.stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.stat-card {\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 6px;\n    padding: 16px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    transition: all 0.2s ease;\n}\n\n.stat-card:hover {\n    border-color: #0088ff;\n    box-shadow: 0 0 10px rgba(0, 255, 0, 0.2);\n}\n\n.stat-icon {\n    font-size: 24px;\n    opacity: 0.8;\n}\n\n.stat-content {\n    flex: 1;\n}\n\n.stat-value {\n    font-size: 20px;\n    font-weight: bold;\n    color: #0088ff;\n    line-height: 1;\n}\n\n.stat-label {\n    font-size: 11px;\n    color: #cccccc;\n    text-transform: uppercase;\n    margin-top: 4px;\n}\n\n/* Charts */\n.overview-charts {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n}\n\n.chart-container {\n    background: rgba(0, 255, 0, 0.02);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 6px;\n    padding: 16px;\n}\n\n.chart-container h3 {\n    margin: 0 0 12px 0;\n    font-size: 14px;\n    color: #0088ff;\n}\n\n.chart-container canvas {\n    width: 100%;\n    height: auto;\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 4px;\n}\n\n/* Players Tab Styles */\n.players-analytics {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n}\n\n.top-players-section h3,\n.player-stats-section h3 {\n    margin: 0 0 16px 0;\n    font-size: 16px;\n    color: #0088ff;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.3);\n    padding-bottom: 8px;\n}\n\n.players-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.top-player-card {\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 6px;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.top-player-card:hover {\n    border-color: #0088ff;\n    background: rgba(0, 255, 0, 0.1);\n}\n\n.top-player-card.rank-1 {\n    border-color: #ffd700;\n    background: rgba(255, 215, 0, 0.1);\n}\n\n.top-player-card.rank-2 {\n    border-color: #c0c0c0;\n    background: rgba(192, 192, 192, 0.1);\n}\n\n.top-player-card.rank-3 {\n    border-color: #cd7f32;\n    background: rgba(205, 127, 50, 0.1);\n}\n\n.player-rank {\n    font-size: 18px;\n    font-weight: bold;\n    color: #0088ff;\n    min-width: 30px;\n}\n\n.player-info {\n    flex: 1;\n}\n\n.player-name {\n    font-size: 14px;\n    font-weight: bold;\n    color: #ffffff;\n    margin-bottom: 4px;\n}\n\n.player-stats {\n    display: flex;\n    gap: 12px;\n    font-size: 11px;\n    color: #cccccc;\n}\n\n.player-score {\n    font-size: 16px;\n    font-weight: bold;\n    color: #0088ff;\n}\n\n/* Player Search */\n.player-search {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 16px;\n}\n\n.player-search input {\n    flex: 1;\n    background: #2a4a2a;\n    border: 1px solid #0088ff;\n    border-radius: 4px;\n    color: #ffffff;\n    padding: 8px 12px;\n    font-family: inherit;\n    font-size: 12px;\n}\n\n.player-search button {\n    background: #2a4a2a;\n    border: 1px solid #0088ff;\n    border-radius: 4px;\n    color: #0088ff;\n    padding: 8px 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.player-search button:hover {\n    background: #0088ff;\n    color: #1a3a1a;\n}\n\n/* Player Details */\n.player-details {\n    background: rgba(0, 255, 0, 0.02);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 6px;\n    padding: 16px;\n    min-height: 200px;\n}\n\n.no-selection {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    color: #666666;\n    font-style: italic;\n}\n\n.player-header {\n    margin-bottom: 16px;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.3);\n    padding-bottom: 8px;\n}\n\n.player-header .player-name {\n    font-size: 18px;\n    color: #0088ff;\n    margin-bottom: 4px;\n}\n\n.player-id {\n    font-size: 11px;\n    color: #666666;\n}\n\n.player-stats-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n    margin-bottom: 16px;\n}\n\n.stat-item {\n    display: flex;\n    justify-content: space-between;\n    padding: 4px 0;\n}\n\n.stat-item .label {\n    color: #cccccc;\n    font-size: 11px;\n}\n\n.stat-item .value {\n    color: #ffffff;\n    font-weight: bold;\n}\n\n.trend-improving {\n    color: #0088ff !important;\n}\n\n.trend-declining {\n    color: #ff6600 !important;\n}\n\n.trend-stable {\n    color: #ffff00 !important;\n}\n\n/* Races Tab Styles */\n.race-filters {\n    display: flex;\n    gap: 16px;\n    margin-bottom: 20px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.2);\n}\n\n.race-filters select {\n    background: #2a4a2a;\n    border: 1px solid #0088ff;\n    border-radius: 4px;\n    color: #ffffff;\n    padding: 6px 10px;\n    font-size: 12px;\n    font-family: inherit;\n}\n\n/* Tables */\n.races-table,\n.bets-table {\n    background: rgba(0, 255, 0, 0.02);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 6px;\n    overflow: hidden;\n}\n\n.table-header {\n    background: rgba(0, 255, 0, 0.1);\n    display: grid;\n    grid-template-columns: 1fr 1fr 80px 60px 1fr;\n    padding: 8px 12px;\n    font-size: 11px;\n    font-weight: bold;\n    color: #0088ff;\n    text-transform: uppercase;\n}\n\n.table-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr 80px 60px 1fr;\n    padding: 8px 12px;\n    font-size: 12px;\n    border-top: 1px solid rgba(0, 255, 0, 0.1);\n    transition: background 0.2s ease;\n}\n\n.table-row:hover {\n    background: rgba(0, 255, 0, 0.05);\n}\n\n.table-row.win {\n    border-left: 3px solid #0088ff;\n}\n\n.table-row.lose {\n    border-left: 3px solid #ff6600;\n}\n\n.table-row.pending {\n    border-left: 3px solid #ffff00;\n}\n\n/* Betting Tab Styles */\n.betting-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.betting-stat-card {\n    background: rgba(255, 102, 0, 0.05);\n    border: 1px solid rgba(255, 102, 0, 0.3);\n    border-radius: 6px;\n    padding: 16px;\n    text-align: center;\n}\n\n.betting-stat-card .stat-value {\n    font-size: 18px;\n    font-weight: bold;\n    color: #ff6600;\n    line-height: 1;\n}\n\n.betting-stat-card .stat-label {\n    font-size: 11px;\n    color: #cccccc;\n    text-transform: uppercase;\n    margin-top: 4px;\n}\n\n.betting-charts {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n    margin-bottom: 24px;\n}\n\n/* Maps Tab Styles */\n.map-stats {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.map-stat-card {\n    background: rgba(255, 255, 0, 0.05);\n    border: 1px solid rgba(255, 255, 0, 0.3);\n    border-radius: 6px;\n    padding: 16px;\n}\n\n.map-name {\n    font-size: 14px;\n    font-weight: bold;\n    color: #ffff00;\n    margin-bottom: 12px;\n    text-transform: uppercase;\n}\n\n.map-stats-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n}\n\n.map-stat {\n    display: flex;\n    justify-content: space-between;\n    font-size: 11px;\n}\n\n.map-stat .label {\n    color: #cccccc;\n}\n\n.map-stat .value {\n    color: #ffffff;\n    font-weight: bold;\n}\n\n/* Trends Tab Styles */\n.trend-indicators {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.trend-card {\n    background: rgba(0, 255, 255, 0.05);\n    border: 1px solid rgba(0, 255, 255, 0.3);\n    border-radius: 6px;\n    padding: 16px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.trend-icon {\n    font-size: 24px;\n}\n\n.trend-value {\n    font-size: 16px;\n    font-weight: bold;\n    line-height: 1;\n}\n\n.trend-value.positive {\n    color: #0088ff;\n}\n\n.trend-value.negative {\n    color: #ff6600;\n}\n\n.trend-value.neutral {\n    color: #ffff00;\n}\n\n.trend-label {\n    font-size: 11px;\n    color: #cccccc;\n    text-transform: uppercase;\n    margin-top: 4px;\n}\n\n.trend-charts {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 20px;\n}\n\n/* Notifications */\n.notification {\n    position: fixed;\n    top: 10px;\n    right: 10px;\n    background: #2a4a2a;\n    border: 1px solid #0088ff;\n    border-radius: 4px;\n    color: #ffffff;\n    padding: 8px 16px;\n    font-size: 12px;\n    z-index: 2000;\n    opacity: 0;\n    transform: translateX(100%);\n    transition: all 0.3s ease;\n}\n\n.notification.show {\n    opacity: 1;\n    transform: translateX(0);\n}\n\n.notification.success {\n    border-color: #0088ff;\n    background: rgba(0, 255, 0, 0.1);\n}\n\n.notification.error {\n    border-color: #ff6600;\n    background: rgba(255, 102, 0, 0.1);\n}\n\n.notification.info {\n    border-color: #ffff00;\n    background: rgba(255, 255, 0, 0.1);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n    #analytics-panel {\n        width: 90vw;\n        right: 5vw;\n    }\n    \n    .players-analytics {\n        grid-template-columns: 1fr;\n    }\n    \n    .overview-charts {\n        grid-template-columns: 1fr;\n    }\n    \n    .betting-charts {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 768px) {\n    #analytics-panel {\n        width: 95vw;\n        right: 2.5vw;\n        max-height: 90vh;\n    }\n    \n    .stats-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n    \n    .betting-stats-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n    \n    .map-stats {\n        grid-template-columns: 1fr;\n    }\n    \n    .trend-indicators {\n        grid-template-columns: 1fr;\n    }\n    \n    .table-header,\n    .table-row {\n        font-size: 10px;\n        padding: 6px 8px;\n    }\n}\n\n/* Animation Classes */\n.updating {\n    opacity: 0.7;\n    transition: opacity 0.3s ease;\n}\n\n.chart-loading {\n    position: relative;\n}\n\n.chart-loading::after {\n    content: \"Loading...\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: #0088ff;\n    font-size: 14px;\n}\n\n/* No Data States */\n.no-data {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100px;\n    color: #666666;\n    font-style: italic;\n    border: 1px dashed rgba(255, 255, 255, 0.2);\n    border-radius: 4px;\n    background: rgba(0, 0, 0, 0.1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
